var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: ', ';\n  color: ', ';\n  ', '\n'], ['\n  font-family: ', ';\n  color: ', ';\n  ', '\n']),
  _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  padding-bottom: 1.5rem;\n'], ['\n  color: ', ';\n  padding-bottom: 1.5rem;\n']),
  _templateObject3 = _taggedTemplateLiteralLoose(['\n  text-align: right;\n  padding: 10px 0 0;\n'], ['\n  text-align: right;\n  padding: 10px 0 0;\n']);
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { is } from 'ramda';
import Theme from '../../../Theme';
import CommentCol from './CommentCol';
import ScoreCol from './ScoreCol';
import { Button } from '../../Dashboard';
import { closeFeedbackFormAnim } from '../animations';
var Montserrat = Theme.fonts.Montserrat;
var _Theme$colors = Theme.colors,
  primary = _Theme$colors.primary,
  blueGrey = _Theme$colors.blueGrey;
var FormWrapper = styled(Container)(_templateObject, Montserrat, blueGrey, function (props) {
  return props.hide && closeFeedbackFormAnim;
});
var Heading = styled.h5(_templateObject2, primary);
var ButtonHolder = styled(Col).attrs({
  xs: 12
})(_templateObject3);
var HeadingRow = function HeadingRow() {
  return React.createElement(Row, null, React.createElement(Col, null, React.createElement(Heading, null, "What do you think about the changes we\u2019ve made?")));
};
var FeedbackForm = function FeedbackForm(_ref) {
  var onFormSubmit = _ref.onFormSubmit,
    hide = _ref.hide,
    onScoreSelect = _ref.onScoreSelect,
    onCommentChange = _ref.onCommentChange,
    comment = _ref.comment,
    score = _ref.score;
  return React.createElement('form', {
    onSubmit: onFormSubmit,
    id: 'feedback-form-anchor'
  }, React.createElement(FormWrapper, {
    hide: hide ? 1 : undefined
  }, React.createElement(HeadingRow, null), React.createElement(Row, null, React.createElement(ScoreCol, {
    onScoreClick: onScoreSelect,
    score: score
  }), React.createElement(CommentCol, {
    comment: comment,
    onCommentChange: onCommentChange
  })), React.createElement(ButtonHolder, null, React.createElement(Button, {
    type: 'submit',
    disabled: !is(Number, score)
  }, 'Submit'))));
};
FeedbackForm.propTypes = process.env.NODE_ENV !== "production" ? {
  onFormSubmit: PropTypes.func.isRequired,
  onScoreSelect: PropTypes.func.isRequired,
  onCommentChange: PropTypes.func.isRequired,
  hide: PropTypes.bool,
  comment: PropTypes.string,
  score: PropTypes.number
} : {};
export default FeedbackForm;